export default __webpack_public_path__ + "static/media/policy11_2023.d2e9ff94.jpg";